// import Foot from "../../components/Footer/Foot";
import Form from "../../components/Form/Form";
// import Nav from "../../components/Navbar/Nav";

function Provinces(){
    return(
        
        //merender dari react-router
        <div>
            {/* <Nav /> */}
            <Form />
            
            {/* <Foot /> */}
            
        </div>
    )
}

export default Provinces;